import Nav from "@/react/story/components/navs/Nav";
import Page from "@/react/story/components/Page";
import PageAdd from "@/react/story/components/PageAdd";
import Viewer from "@/react/story/components/viewers/Viewer";
import { useConfig } from "@/react/story/providers/ConfigContext";
import { useItems } from "@/react/story/providers/ItemsContext";
import { useStory } from "@/react/story/providers/StoryContext";

export default function StoryEditor() {
    const Config = useConfig();
    const Story = useStory();
    const Items = useItems();

    return (
        <div className={Config.isFullscreen ? "fullscreen" : ""}>
            <div className="d-flex gap-3 h-100">
                <div
                    className="flex-grow-0 flex-shrink-0 pe-3 border-end overflow-auto"
                    style={{ flexBasis: "18rem" }}
                >
                    <Nav />
                </div>
                <div className="flex-grow-1 overflow-auto">
                    {Items.current ? (
                        <Page key={Items.current.id} />
                    ) : (
                        <PageAdd />
                    )}
                </div>
                {Items.current ? (
                    <div className="flex-grow-0 flex-shrink-0 overflow-auto">
                        {Story.story ? (
                            <Viewer />
                        ) : null}
                        {Config.storyPermalink ? (
                            <div className="mt-3 text-center">
                                <a href={Config.storyPermalink} target="_blank" rel="noreferrer">
                                    <span className="bi-link-45deg"></span> Voir la story
                                </a>
                            </div>
                        ) : null}
                    </div>
                ) : null}
            </div>
        </div>
    );
}
